import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, printerName, isLoading }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 z-50 transition-opacity"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-card border border-border rounded-lg shadow-elevation-2 w-full max-w-md">
          {/* Header */}
          <div className="flex items-center space-x-3 p-6 border-b border-border">
            <div className="w-10 h-10 bg-destructive/10 rounded-full flex items-center justify-center">
              <Icon name="AlertTriangle" size={20} className="text-destructive" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-foreground">
                Confirmar Exclusão
              </h3>
              <p className="text-sm text-muted-foreground">
                Esta ação não pode ser desfeita
              </p>
            </div>
          </div>

          {/* Content */}
          <div className="p-6">
            <p className="text-foreground mb-4">
              Tem certeza que deseja excluir a impressora{' '}
              <span className="font-semibold text-primary">"{printerName}"</span>?
            </p>
            
            <div className="bg-muted rounded-lg p-4 mb-4">
              <div className="flex items-start space-x-2">
                <Icon name="Info" size={16} className="text-muted-foreground mt-0.5 flex-shrink-0" />
                <div className="text-sm text-muted-foreground">
                  <p className="mb-2">Ao excluir esta impressora:</p>
                  <ul className="list-disc list-inside space-y-1 ml-2">
                    <li>Todo o histórico de impressões será perdido</li>
                    <li>Dados de uso e estatísticas serão removidos</li>
                    <li>Configurações personalizadas serão apagadas</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center space-x-3 p-6 border-t border-border">
            <Button
              variant="outline"
              onClick={onClose}
              disabled={isLoading}
              className="flex-1"
            >
              Cancelar
            </Button>
            <Button
              variant="destructive"
              onClick={onConfirm}
              loading={isLoading}
              iconName="Trash2"
              iconPosition="left"
              className="flex-1"
            >
              Excluir
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteConfirmModal;